export default {
    open: 'curtain-open',
    close: 'curtain-close',
    recalculate: 'curtain-recalculate'
};
